import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { AssessmentService } from "../../../services/assessment.service";
import { User } from "../../../shared/models/user";
import { ApiCallService } from "../../../services/api-call.service";
import { ErrorMessageService } from "../../../services/error-message.service";
import { UserGroup } from "../../../shared/models/user-group";
import { RemoveUserComponent } from "../../../shared/warning-popups/remove-user/remove-user.component";
import {MatDialog} from "@angular/material/dialog";
import { RemoveGroupComponent } from "../../../shared/warning-popups/remove-group/remove-group.component";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { LightLoaderComponent } from "../../../shared/loaders/light-loader/light-loader.component";
import { AccreditationService } from "../../../services/accreditation.service";
import {Observable, Subscription} from "rxjs";
import {AccreditationResponse} from "../../../shared/models/accreditation-response";

@Component({
    selector: 'team-users',
    templateUrl: './team-users.component.html',
    styleUrls: ['./team-users.component.scss'],
    standalone: false
})
export class TeamUsersComponent implements OnInit, OnDestroy {
  @Input() projectRequestKey: string;
  @Input() responseRequestKey: string;
  @Input() accreditationResponseObservable: Observable<AccreditationResponse>;
  @Input() programRequestKey: string;
  @Input() applicationType: number;
  @Input() responseIsLockedForEdit: boolean = true;
  @Output() teamCount = new EventEmitter<number>();
  appType = applicationType;
  @BlockUI('bulkUsersUI') blockUI: NgBlockUI;
  blockTemplate: LightLoaderComponent = LightLoaderComponent;
  projectLocked: boolean;
  closed: boolean = false;
  addExpanded: boolean = false;
  viewByExpanded: boolean = false;
  editExpanded: boolean = true;
  commentExpanded: boolean = true;
  readExpanded: boolean = true;
  adminsExpanded: boolean = false;
  evaluatorsExpanded: boolean = false;
  viewBy: string = "ALL";
  reloading: boolean = true;


  allUsers: userInfo[]; //all users of the organization, as they come from the remote
  allGroups: UserGroup[] = []; //all available groups of the organization

  everyUser: User[] = []; //all team users

  editMembers: User[] = []; //edit members (individuals only)
  commentMembers: User[] = []; //comment members (individuals only)
  readMembers: User[] = []; //read members (individuals only)
  adminMembers: User[] = []; //admin members (individuals only)
  evalMembers: User[] = []; //evaluator members (individuals only)


  editGroups: UserGroup[] = []; //edit groups
  commentGroups: UserGroup[] = []; //comment groups
  readGroups: UserGroup[] = []; //read groups

  /* counters */
  allCount: number = 0;
  editCount: number = 0;
  commentCount: number = 0;
  readCount: number = 0;
  adminCount: number = 0;
  evalCount: number = 0;

  /* filters */
  readFilter: boolean = true;
  commentFilter: boolean = true;
  editFilter: boolean = true;
  adminFilter: boolean = true;
  evalFilter: boolean = true;
  individualsFilter: boolean = true;
  groupsFilter: boolean = true;

  subscribers: Subscription[] = [];

  constructor(public AssessmentService: AssessmentService,
              public AccreditationService: AccreditationService,
              public apiCallService: ApiCallService,
              public errorMessage: ErrorMessageService,
              public dialog: MatDialog,
  ) { }

  ngOnInit() {
    if(this.applicationType === applicationType.assessment){
      this.projectLocked = false;
      //this.AssessmentService.updateLeftClosed(false);
      this.subscribers.push(
        this.AssessmentService.locked.subscribe(data => {
          this.projectLocked = data;
        })
      );
      this.getProjectTeam();
    }
    else{ //Accreditation
      this.projectLocked = this.responseIsLockedForEdit;
      this.subscribers.push(
        this.accreditationResponseObservable.subscribe((response) => {
          if(response){
            this.projectRequestKey = response.projectRequestKey;
            this.responseRequestKey = response.requestKey;
            this.getProjectTeam();
          }
        })
      )

    }

    if(this.applicationType == applicationType.assessment) {
      this.subscribers.push(
        this.AssessmentService.leftClosed.subscribe(data => {
          this.closed = data;
        })
      );
    } else {
      this.subscribers.push(
        this.AccreditationService.leftClosed.subscribe(data => {
          this.closed = data;
        })
      );
    }

  }

  minimizePanel() {
    this.closed = true;
    if(this.applicationType == applicationType.assessment) {
      this.AssessmentService.updateLeftClosed( true, this.projectRequestKey );
    } else {
      this.AccreditationService.updateIsLeftClosed(true);
    }
  }
  openPanel() {
    this.closed = false;
    if(this.applicationType == applicationType.assessment) {
      this.AssessmentService.updateLeftClosed(false, this.projectRequestKey);
    } else {
      this.AccreditationService.updateIsLeftClosed(false);
    }

  }

  getProjectTeam()  {
    this.reloading = true;
    this.blockUI.start();
    this.subscribers.push(
      this.apiCallService.postJsonData('/aeAMSgetProjectMembers/', {
        projectGuid : this.projectRequestKey,
        responseGuid : this.responseRequestKey ? this.responseRequestKey : ""
      }).subscribe((response) => {
        if (response.success && response.data[0]) {
          this.everyUser = [];
          this.adminCount = 0;
          this.evalCount = 0;

          this.editMembers = [];
          this.commentMembers = [];
          this.readMembers = [];
          this.adminMembers = [];
          this.evalMembers = [];

          this.allUsers = response.data[0].dataSet.allUsers;
          //Evaluators
          let programEvaluators = response.data[1].dataSet.programEvaluators || [];
          let accreditationManagers = response.data[1].dataSet.accreditationManagers || [];
          let accreditationHistoric = response.data[1].dataSet.accreditationHistoric || [];
          let evaluators = programEvaluators.concat(accreditationManagers, accreditationHistoric);
          let programManagers = response.data[1].dataSet.programManagers;
          if(this.applicationType === this.appType.assessment){
            evaluators = [];
            programManagers = [];
          }
          evaluators.forEach((user) =>{
            let filtered = this.findUser(user);
            let userInfo = filtered[0];
            if(userInfo != null ) {
              let teamMember = new User(
                userInfo.member.profilePicture,
                userInfo.member.id,
                userInfo.member.name,
                userInfo.member.firstName,
                userInfo.member.lastName,
                userInfo.member.requestKey,
                userInfo.isInstitutionAdmin,
                true,
                false,
                false,
                false
              );
              this.everyUser.push( teamMember );
              this.evalMembers.push( teamMember );
            }
          });
          //admins
          this.allUsers.forEach(user => {
            if( user.isInstitutionAdmin && !this.userIsEvaluator(user.member.requestKey)) {
              let adminMember = new User(
                user.member.profilePicture,
                user.member.id,
                user.member.name,
                user.member.firstName,
                user.member.lastName,
                user.member.requestKey,
                user.isInstitutionAdmin,
                false,
                false,
                true,
                true
              );
              this.adminMembers.push( adminMember );
              this.everyUser.push( adminMember );
            }
          });


          //individual users
          let individuals = response.data[0].dataSet.individualTeamMembers;
          individuals.forEach((user) => {
            if(!this.userIsEvaluator(user.requestKey)) {
              let filtered = this.findUser(user.requestKey);
              let userInfo = filtered[0];
              if (userInfo != null) {
                let teamMember = new User(
                  userInfo.member.profilePicture,
                  userInfo.member.id,
                  userInfo.member.name,
                  userInfo.member.firstName,
                  userInfo.member.lastName,
                  userInfo.member.requestKey,
                  userInfo.isInstitutionAdmin,
                  false,
                  this.userIsProgramManager(userInfo.member.requestKey, programManagers),
                  user.individualAccess.allowComment,
                  user.individualAccess.allowEdit
                );
                this.everyUser.push(teamMember);
                if (user.individualAccess.allowEdit && !teamMember.isAdmin) {
                  this.editMembers.push(teamMember);
                } else if (user.individualAccess.allowComment && !teamMember.isAdmin) {
                  this.commentMembers.push(teamMember);
                } else if (!teamMember.isAdmin) {
                  this.readMembers.push(teamMember);
                }
              } else {
                console.error("There was a problem with getting a team member: Cannot find user details for user with id " + user.requestKey);
                //this.errorMessage.showErrorModal("There was a problem with getting a team member", ["Cannot find user details for user with id " + user.requestKey]);
              }
            }
          });

          //groups
          this.editGroups = [];
          this.commentGroups = [];
          this.readGroups = [];
          let groups: groupData[] = response.data[0].dataSet.groups || [];
          groups.forEach((group: groupData)=>{
            //override comment access for assessment
            if(this.applicationType === applicationType.assessment && !group.access.allowEdit){
              group.access.allowComment = false;
            }
            let groupMembers: User[] = [];
            group.members.forEach((requestKey: string) => {
              let filtered = this.findUser(requestKey);
              let userInfo = filtered[0];
              if( userInfo != null ) {
                let teamMember = new User(
                  userInfo.member.profilePicture,
                  userInfo.member.id,
                  userInfo.member.name,
                  userInfo.member.firstName,
                  userInfo.member.lastName,
                  userInfo.member.requestKey,
                  userInfo.isInstitutionAdmin,
                  false,
                  this.userIsProgramManager(userInfo.member.requestKey, programManagers),
                  group.access.allowComment,
                  group.access.allowEdit
                );
                this.everyUser.push( teamMember );
                groupMembers.push( teamMember );
              } else {
                console.error("There was a problem with getting a group team member: Cannot find information about user with id " + requestKey);
                //this.errorMessage.showErrorModal("There was a problem with getting a group team member", ["cannot find information about user with id " + requestKey]);
              }
            });
            let newGroup = new UserGroup(
              group.name,
              group.requestKey,
              groupMembers,
              group.access.allowComment,
              group.access.allowEdit
            );

            if(group.access.allowEdit) {
              this.editGroups.push( newGroup );
            }else if(group.access.allowComment) {
              this.commentGroups.push( newGroup );
            }else {
              this.readGroups.push( newGroup );
            }
          });

          //counters
          this.clearDuplicatesForAll();
          this.sortAllUsers();
          this.countUsersShown();

          //since we are here, let's get all groups, too, just in case
          this.getAllGroups();
        }
        else{
          this.errorMessage.showErrorModal("There was a problem with getting the team members.", response.dataError);
        }
        this.teamCount.emit(this.everyUser.length);
        this.reloading = false;
        this.blockUI.stop();
      })
    );
  };

  addIndividual(member: User) {
    this.subscribers.push(
      this.apiCallService.postJsonData('/aeAMSSetProjectAccess/',
        { userGuid: member.member.requestKey,
          projectGuid: this.projectRequestKey,
          allowView: true,
          allowComment: member.individualAccess.allowComment,
          allowEdit: member.individualAccess.allowEdit
        }).subscribe((response) => {
        if(response.success) {
          //reload users
          this.getProjectTeam();
        }
        else{
          this.errorMessage.showErrorModal("There was a problem with adding the user.", response.dataError);
        }
      })
    );
  }

  getAllGroups() {
    let postObject = {
      iDisplayStart : 0,
      iDisplayLength : 9999
    };
    this.subscribers.push(
      this.apiCallService.postJsonData('/aeAMSgetShortUserGroupList/', postObject).subscribe((response) => {
        if (response.success && response.data[0]) {
          this.allGroups = [];
          response.data[0].dataSet.forEach(groupInfo => {
            //override comment access for Assessment
            if(this.applicationType === applicationType.assessment && !groupInfo.allowEdit){
              groupInfo.allowComment = false;
            }
            //create users
            let groupMembers: User[] = [];
            groupInfo.allUsers.forEach((tempUser) => {
              let requestKey = tempUser.requestKey
              let filtered = this.findUser(requestKey);
              let userInfo = filtered[0];
              if( userInfo != null ) {
                let teamMember = new User(
                  userInfo.member.profilePicture,
                  userInfo.member.id,
                  userInfo.member.name,
                  userInfo.member.firstName,
                  userInfo.member.lastName,
                  userInfo.member.requestKey,
                  userInfo.isInstitutionAdmin,
                  false,
                  false,
                  groupInfo.allowComment,
                  groupInfo.allowEdit
                );
                groupMembers.push( teamMember );
              } else {
                console.error("There was a problem with getting a group team member: Cannot find information about user with id " + requestKey);
                //this.errorMessage.showErrorModal("There was a problem with getting a group team member", ["cannot find information about user with id " + requestKey]);
              }
            });
            let userGroup = new UserGroup();
            userGroup.name = groupInfo.name;
            userGroup.guid = groupInfo.requestKey;
            userGroup.access = {
              allowComment: groupInfo.allowComment,
              allowEdit: groupInfo.allowEdit
            };
            userGroup.members = groupMembers;
            this.allGroups.push( userGroup );
          });
        }
      })
    );
  }

  addGroup(group: UserGroup) {
    this.subscribers.push(
      this.getGroupProjects(group).subscribe((response) => {
        if( response.success && response.data[ 0 ] ) {
          let newAssessmentProjectsList = this.transformListToGUIDArray( response.data[ 0 ].dataSet.assessmentProjectList );
          let accreditationProjectsList = this.transformListToGUIDArray( response.data[0].dataSet.accreditationProjectList );
          let programList = this.transformListToGUIDArray( response.data[0].dataSet.accreditationProgramList );
          if(this.applicationType === this.appType.assessment){
            newAssessmentProjectsList.push(this.projectRequestKey);
          }
          else{
            accreditationProjectsList.push(this.projectRequestKey);
          }
          //send updated list setUserGroupProjectsAndPrograms
          this.subscribers.push(
            this.apiCallService.postJsonData( '/aeAMSsetUserGroupProjectsAndPrograms/',
              {
                userGroupGuid: group.guid,
                accreditationProjectGuidList: accreditationProjectsList,
                assessmentProjectGuidList: newAssessmentProjectsList,
                programGuidList: programList
              } ).subscribe( ( response ) => {
              if( response && response.success ) {
                //reload users
                this.getProjectTeam();
              } else {
                this.errorMessage.showErrorModal( "There was a problem with removing the User Group from this project", response.dataError );
              }
            })
          );
        }
      })
    );
  }

  changeUserAccess(member:User) { //todo currently both comment and edit change at the same time!
    this.subscribers.push(
      this.apiCallService.postJsonData('/aeAMSSetProjectAccess/',
        {userGuid: member.member.requestKey,
          projectGuid: this.projectRequestKey,
          allowView: true,
          allowComment: member.individualAccess.allowComment,
          allowEdit: member.individualAccess.allowEdit,
        }).subscribe((response) => {
        if(response.success) {
          //reload everything
          this.getProjectTeam();
        }
        else{
          this.errorMessage.showErrorModal("There was a problem with adding the user.", response.dataError);
        }
      })
    );
  }

  removeUserWarning(user:User) {
    const dialogRef = this.dialog.open(RemoveUserComponent, {
      width: '600px',
      data: {element: user}
    });
    this.subscribers.push(
      dialogRef.afterClosed().subscribe(result => {
        if(result) {
          this.subscribers.push(
            this.apiCallService.postJsonData('/aeAMSSetProjectAccess/', {
                userGuid: user.member.requestKey,
                projectGuid: this.projectRequestKey,
                allowView: false,
                allowComment: false,
                allowEdit: false
            }).subscribe((response) => {
              if(response.success) {
                this.getProjectTeam();
              } else {
                this.errorMessage.showErrorModal("There was a problem with removing user.", response.dataError);
              }
            })
          );
        };
      })
    );
  }

  getGroupProjects(group: UserGroup) {
    return this.apiCallService.postJsonData(
      '/aeAMSgetUserGroupProjectList/',
      {usergroupguid: group.guid}
    );
  }

  removeGroupWarning(group: UserGroup) {
    const dialogRef = this.dialog.open(RemoveGroupComponent, {
      width: '600px',
      data: {element: group}
    });
    // this.subscribers.push(
    //   dialogRef.afterClosed().subscribe(result => {
    //     if(result) {
    //       //get all groups getUserGroupProjectList
    //       this.subscribers.push(
    //         this.getGroupProjects(group).subscribe((response) => {
    //           if( response.success && response.data[ 0 ] ) {
    //             let newAssessmentProjectsList = response.data[ 0 ].dataSet.assessmentProjectList.filter( ( item ) => {
    //               return item.project.requestKey && ( item.project.requestKey.toLowerCase() != this.projectRequestKey );
    //             } );
    //             //send updated list setUserGroupProjectsAndPrograms
    //             let assessmentProjectGuidList = [];
    //             if(newAssessmentProjectsList.length) {
    //               assessmentProjectGuidList = this.transformListToGUIDArray( newAssessmentProjectsList );
    //             }

    //             let newAccreditationProjectList = response.data[0].dataSet.accreditationProjectList.filter((item) =>{
    //               return item.project.requestKey.toLowerCase() !== this.projectRequestKey.toLowerCase();
    //             });
    //             let accreditationProjectsList = [];
    //             if(newAccreditationProjectList.length){
    //               accreditationProjectsList = this.transformListToGUIDArray(newAccreditationProjectList);
    //             }
    //             let programList = this.transformListToGUIDArray( response.data[0].dataSet.accreditationProgramList );
    //             this.subscribers.push(
    //               this.apiCallService.postJsonData( '/aeAMSsetUserGroupProjectsAndPrograms/',
    //                 {
    //                   userGroupGuid: group.guid,
    //                   accreditationProjectGuidList: accreditationProjectsList,
    //                   assessmentProjectGuidList: assessmentProjectGuidList,
    //                   programGuidList: programList
    //                 } ).subscribe( ( response ) => {
    //                 if( response && response.success ) {
    //                   //reload users
    //                   group.expanded = false;
    //                   this.getProjectTeam();
    //                 } else {
    //                   this.errorMessage.showErrorModal( "There was a problem with removing the User Group from this project", response.dataError );
    //                 }
    //               })
    //             );
    this.subscribers.push(
      dialogRef.afterClosed().subscribe(result => {
        if(result) {
          //get all groups getUserGroupProjectList
          this.subscribers.push(
            this.getGroupProjects(group).subscribe((response) => {
                if( response.success && response.data[ 0 ] ) {
                  let newAssessmentProjectsList = response.data[ 0 ].dataSet.assessmentProjectList.filter( ( item ) => {
                    return item.project.requestKey && ( item.project.requestKey.toLowerCase() != this.projectRequestKey );
                  } );
                  //send updated list setUserGroupProjectsAndPrograms
                  let assessmentProjectGuidList = [];
                  if( newAssessmentProjectsList.length ) {
                    assessmentProjectGuidList = this.transformListToGUIDArray( newAssessmentProjectsList );
                  }

                  let newAccreditationProjectList = response.data[ 0 ].dataSet.accreditationProjectList.filter( ( item ) => {
                    return item.project.requestKey.toLowerCase() !== this.projectRequestKey.toLowerCase();
                  } );
                  let accreditationProjectsList = [];
                  if( newAccreditationProjectList.length ) {
                    accreditationProjectsList = this.transformListToGUIDArray( newAccreditationProjectList );
                  }
                  let initialProgramList = this.transformListToGUIDArray( response.data[ 0 ].dataSet.accreditationProgramList );
                  let programList = initialProgramList.filter( ( programGUID ) => {
                    return programGUID.toLowerCase() !== this.programRequestKey;
                  } );
                  let remoteMethodAddon = "/aeAMSsetUserGroupProjectsAndPrograms/";
                  let postedData = {
                    userGroupGuid: group.guid,
                    accreditationProjectGuidList: accreditationProjectsList,
                    assessmentProjectGuidList: assessmentProjectGuidList,
                    programGuidList: programList,
                  };

                  if( programList.length !== initialProgramList.length ) {
                    postedData[ "currentProjectGuid" ] = this.projectRequestKey;
                    remoteMethodAddon = "/aeAMSsetUserGroupAccreditationProject/";
                  }
                  this.apiCallService.postJsonData( remoteMethodAddon, postedData ).subscribe( ( response ) => {
                    if( response && response.success ) {
                      //reload users
                      group.expanded = false;
                      this.getProjectTeam();
                    } else {
                      this.errorMessage.showErrorModal( "There was a problem with removing the User Group from this project", response.dataError );
                    }
                  } )
                }
              }
            )
          )
        }
      })
    );
  }

  transformListToGUIDArray(list) {
    return list.map( function( a ) {
      return a.project.requestKey;
    } );
  }

  userIsEvaluator(requestKey: string){
    return this.evalMembers.filter((user) =>{
      return user.member.requestKey.toLowerCase() === requestKey.toLowerCase();
    }).length !== 0;
  }

  userIsProgramManager(requestKey: string, programManagerGUIDArr: string[]){
    return programManagerGUIDArr.filter((guid) =>{
      return requestKey.toLowerCase() === guid.toLowerCase();
    }).length !== 0;
  }

  findUser(requestKey: string) {
    return this.allUsers.filter((item:userInfo) => {
      return item.member.requestKey.toLowerCase() == requestKey.toLowerCase();
    });
  }

  findUserInEditGroups(requestKey:string) {
    let counter = 0;
    this.editGroups.forEach(group => {
      group.members.forEach(member => {
        if(member.member.requestKey.toLowerCase()  == requestKey.toLowerCase()) {
          counter++;
        }
      });
    });
    return counter;
  }

  findUserInCommentGroups(userId:number) {
    let counter = 0;
    this.commentGroups.forEach(group => {
      group.members.forEach(member => {
        if(member.member.id == userId) {
          counter++;
        }
      });
    });
    return counter;
  }

  clearDuplicatesForAll() {
    this.everyUser = this.removeDuplicates(this.everyUser);
    this.editMembers = this.removeDuplicates(this.editMembers);
    this.commentMembers = this.removeDuplicates(this.commentMembers);
    this.readMembers = this.removeDuplicates(this.readMembers);
    this.adminMembers = this.removeDuplicates(this.adminMembers);
    this.evalMembers = this.removeDuplicates(this.evalMembers);
  }

  removeDuplicates(array:User[]) {
    let cleanArray = (function(array){
      let m = {}, cleanArray = [];
      for (let i=0; i<array.length; i++) {
        let v = array[i].member.requestKey;
        if (!m[v]) {
          cleanArray.push(array[i]);
          m[v]=true;
        }
      }
      return cleanArray;
    })(array);

    return cleanArray;
  }

  sortMembers(members: User[]): User[]{
    return members.sort((memberA, memberB) =>{
      if(memberA.member.name.toLowerCase() < memberB.member.name.toLowerCase()) {return -1;}
      if(memberA.member.name.toLowerCase() > memberB.member.name.toLowerCase()) {return 1;}
      return 0;
    })
  }

  sortAllUsers() {
    this.everyUser = this.sortMembers(this.everyUser);
    this.editMembers = this.sortMembers(this.editMembers);
    this.commentMembers = this.sortMembers(this.commentMembers);
    this.readMembers = this.sortMembers(this.readMembers);
    this.adminMembers = this.sortMembers(this.adminMembers);
    this.evalMembers = this.sortMembers(this.evalMembers);
  }

  /* filters */
  showAll() {
    this.filterMembers( true, true, true, true, true, true, true );
    this.viewBy = "ALL";
  }
  showReadOnly() {
    this.filterMembers( true, false, false, true, true, false, true );
    this.viewBy = "READ ONLY";
  }
  showCommentOnly() {
    this.filterMembers( false, true,false, true, true, true, false );
    this.viewBy = "READ & COMMENT ONLY";
  }
  showEditOnly() {
    this.filterMembers( false, false,true, true, true, true, false );
    this.viewBy = "EDIT ONLY";
  }
  showIndividualsOnly() {
    this.filterMembers( true, true,true, true, false, true, false );
    this.viewBy = "INDIVIDUAL USERS";
  }
  showGroupsOnly() {
    this.filterMembers( true, true,true, false, true, false, false );
    this.viewBy = "GROUPS";
  }
  showAdminsOnly() {
    this.filterMembers( false, true,false, false, false, true, false );
    this.viewBy = "ADMINISTRATORS";
    this.adminsExpanded = true;
  }
  showEvaluatorsOnly() {
    this.filterMembers( false, true,false, false, false, false, true );
    this.viewBy = "EVALUATORS";
    this.evaluatorsExpanded = true;
  }
  filterMembers(read: boolean, comment: boolean, edit: boolean, individuals: boolean, groups: boolean, admins: boolean, evals: boolean) {
    this.readFilter = read;
    this.commentFilter = comment;
    this.editFilter = edit;
    this.individualsFilter = individuals;
    this.groupsFilter = groups;
    this.adminFilter = admins;
    this.evalFilter = evals;
    this.viewByExpanded = false;
    this.countUsersShown();
  }

  countUsersShown() {
    let allUsersShown: User[] = [];
    if( this.individualsFilter && this.groupsFilter ) { //all users
      if( !this.readFilter && !this.commentFilter && this.editFilter) { //edit only
        allUsersShown = allUsersShown.concat( this.editMembers, this.adminMembers );
        this.editGroups.forEach(group => {
          group.members.forEach(member =>{
            allUsersShown.push(member);
          });
        });
      } else if( !this.readFilter && this.commentFilter && !this.editFilter ) { //comment only
        allUsersShown = allUsersShown.concat( this.commentMembers );
        this.commentGroups.forEach(group => {
          group.members.forEach(member => {
            allUsersShown.push(member);
          });
        });
      } else if( this.readFilter && !this.commentFilter && !this.editFilter ) { //read only
        allUsersShown = allUsersShown.concat( this.readMembers );
        this.readGroups.forEach(group => {
          group.members.forEach(member => {
            allUsersShown.push(member);
          });
        });
      } else if( this.readFilter && this.commentFilter && this.editFilter ) { //all
        allUsersShown = allUsersShown.concat( this.readMembers, this.editMembers, this.commentMembers, this.adminMembers, this.evalMembers );
        this.editGroups.forEach(group => {
          group.members.forEach(member =>{
            allUsersShown.push(member);
          });
        });
        this.commentGroups.forEach(group => {
          group.members.forEach(member => {
            allUsersShown.push(member);
          });
        });
        this.readGroups.forEach(group => {
          group.members.forEach(member => {
            allUsersShown.push(member);
          });
        });
      }
    } else if( this.individualsFilter && !this.groupsFilter ) { //individuals, read and edit
      allUsersShown = this.readMembers.concat(this.editMembers, this.adminMembers, this.commentMembers);
    } else if( !this.individualsFilter && this.groupsFilter ) { //groups, read and edit
      let allGroups = this.editGroups.concat(this.readGroups, this.commentGroups);
      allGroups.forEach(group => {
        group.members.forEach(member =>{
          allUsersShown.push(member);
        });
      });
    } else if( this.adminFilter ) { //admins only
      allUsersShown = allUsersShown.concat(this.adminMembers);
    }
    else if( this.evalFilter ) { //evaluators only
      allUsersShown = allUsersShown.concat(this.evalMembers);
    }
    //clean them!
    allUsersShown = this.removeDuplicates(allUsersShown);
    //count them!
    this.allCount = 0;
    this.editCount = 0;
    this.commentCount = 0;
    this.readCount = 0;
    this.adminCount = 0;
    this.evalCount = 0;
    //console.log(allUsersShown)
    allUsersShown.forEach( user => {
     if( user.isEvaluator ) {
        this.allCount++;
        this.evalCount++;
       //also check if user is in a group
       this.editCount += this.findUserInEditGroups(user.member.requestKey);
       this.commentCount += this.findUserInCommentGroups(user.member.id);
      }else if( user.isAdmin) {
        this.allCount++;
        this.adminCount++;
        //also check if user is in a group
        this.editCount += this.findUserInEditGroups(user.member.requestKey);
        this.commentCount += this.findUserInCommentGroups(user.member.id);
      }else if( user.individualAccess.allowEdit && this.editFilter ) {
        this.allCount++;
        this.editCount++;
      } else if( user.individualAccess.allowComment && this.commentFilter ) {
        this.allCount++;
        this.commentCount++;
      }else if( !user.individualAccess.allowEdit && !user.individualAccess.allowComment && this.readFilter ) {
        this.allCount++;
        this.readCount++;
      }
    });
  }

  @HostListener('document:click', ['$event'])
  click(event) {
    if(!event.target.classList.contains('viewByBtn') && this.viewByExpanded === true){
      this.viewByExpanded = false;
    }
  }

  ngOnDestroy() {
    for(let subscriber of this.subscribers){
      subscriber.unsubscribe();
    }
  }
}
interface userInfo {
  member: {
    profilePicture: string;
    id: number;
    name: string;
    firstName: string;
    lastName: string;
    requestKey: string;
  }
  isInstitutionAdmin: boolean;
}
interface groupData {
  name: string;
  requestKey: string;
  access: {
    allowComment: boolean;
    allowEdit: boolean;
  }
  members: string[];
}

export enum applicationType{
  assessment,
  accreditation
}
